import React, {useContext, useState, useEffect} from "react"

// util, context and data
import Util from "../../../util"
import {ShopContext} from "../../../context/ShopContext"
import {CatalogueContext} from "../../../context/CatalogueContext"
import data from "../../../data"
import Config from "../../../config"

// components
import Checkout from "./Checkout"
import {Button, Overlay} from "../../controls"
import {Scaffolding} from "../../shared"
import {Redirect} from "react-router-dom"

// styling & images
import "./Packaging.scss"
import {FullScreen as FullScreenSvg} from "../../../images/js"
import {PackageEta as PackageEtaSvg} from "../../../images/js"

// the component
function Packaging() {
  // state management
  const [selectedCode, setSelectedCode] = useState("PDF")
  const [selectedFullscreen, setSelectedFullscreen] = useState(null)
  const [redirectToPersonalize, setRedirectToPersonalize] = useState(false)

  // context
  const catalogue = useContext(CatalogueContext)
  const shop = useContext(ShopContext)
  
  // process side effects
  useEffect(() => {
    if(catalogue.isReady) {
      setSelectedCode(data.Cart.getShippingType().code)
    }
  }, [catalogue.isReady])

  // scroll to top when mounting
  useEffect(() => { Util.Scroll.scrollToTop()}, [])
  
  // shipping and other data still loading?
  if(!catalogue.isReady) {
    return null
  }

  // select button was clicked
  const onClickSelect = (st) => {
    shop.cart.setShippingType(st);
    setSelectedCode(st.code);
    setRedirectToPersonalize(true);
  }

  // redirect?
  if(redirectToPersonalize) {
    return <Redirect to="/checkout/personalize" />
  }
  

  // packaging
  const shippingTypes = data.ShippingTypes.get()
    .filter(st => st.isActive)
    .sort((a, b) => a.position > b.position ? 1 : -1)
    .map(st => {
      const info = data.ShippingTypes.getInfo(st.code)
      return (
        <div 
          className={`c-shipping-type ${selectedCode === st.code ? "selected boxshadow" : ""}`} 
          key={st.code}
          onClick={
            () => {
              setSelectedCode(st.code)
              shop.cart.setShippingType(st)
            }
          }
        >
          <div className="c-shipping-type-upper">
            <div className="c-shipping-type-title">{st.title["de"]}</div>
            <div className="c-shipping-type-image">
              <img src={st.image.url} alt={st.code} />
              {st.code !== 'PDF' ? <div className="fullscreen" onClick={(e) => {e.stopPropagation();setSelectedFullscreen(st)}}><FullScreenSvg /></div> : null}
            </div>
            <div className="c-shipping-type-description">{st.description.de}</div>
            {/*<div className="c-shipping-type-spacer"></div>*/}
            <div className="c-shipping-type-eta">
              <div className="icon"><PackageEtaSvg /></div>
              <div className="when">{info.when}</div>
            </div>
            <div className="c-shipping-type-price">{Config.currency} {st.price.toFixed(2)}</div>
          </div>

          <div className="c-shipping-type-lower">
            <div className="c-shipping-type-select">
              <Button label="wählen" onClick={() => onClickSelect(st)}/>
            </div>
          </div>

          {/* 
          <div className="title">{st.title["de"]}</div>
          <div className="image">
            <img src={st.image.url} alt={st.code} />
            {st.code !== 'PDF' ? <div className="fullscreen" onClick={(e) => {e.stopPropagation();setSelectedFullscreen(st)}}><FullScreenSvg /></div> : null}
          </div>
          <div className="description">{st.description.de}</div>
          <div className="spacer"></div>
          <div className="eta">
            <div className="icon"><PackageEtaSvg /></div>
            <div className="when">{info.when}</div>
          </div>
          <div className="price">CHF {st.price.toFixed(2)}</div>
          */}
          
          
        </div>
      )
    })

  // shipping eta
  /*
  let shippingInfo = data.Cart.getShippingInfo()
  let shippingInfoHelp = (
    <>
      <div>Postversand:</div>
      <div>Bestellungen bis 11:00 Uhr werden noch am selben Tag verschickt, danach am nächsten Werktag. Sämtliche Sendungen werden per A-Post/Priority verschickt.</div>
      <br />
      <div>PDF-Download:</div>
      <div>Der Download-Link wird unmittelbar nach der Bestellung per E-Mail verschickt.</div>
    </>
  )
  */
  
  // render
  return (
    <Scaffolding>
      <Checkout stepName="packaging" title="Verpackung wählen">
        <div id="v-packaging">
          {/* 
          <div className="shipping-eta">
            Voraussichtliches Lieferdatum: {shippingInfo.when} <Help title="Lieferfristen">{shippingInfoHelp}</Help>
          </div>
          */}
          <div className="c-shipping-types">
            {shippingTypes}
          </div>
        </div>
      </Checkout> 
      <Overlay
        position="center"
        visible={selectedFullscreen !== null}
        close={() => setSelectedFullscreen(null)}
      >
        <div className="c-packaging-fullscreen-overlay">
          <span className="close" onClick={() => {setSelectedFullscreen(null)}}>&times;</span>
          <div className="image">
            {selectedFullscreen ? 
              <img src={selectedFullscreen.image.url} alt={`${selectedFullscreen.title.de}`} /> :
              null
            }
          </div>
        </div>
      </Overlay>
    </Scaffolding>
  )
}

export default Packaging
